import React, { useEffect, useRef, useState } from 'react'
import { Popup, Modal } from 'antd-mobile'
import { CloseOutlined } from '@ant-design/icons'
import general from '../../../../general'
import Dialog from '../../../../lib/Dialog'
import useActiveState from '../../../../lib/useActiveState'
import '../css/Modifyprice.css'
import { useLockFn } from 'ahooks'

export default function Bargain(props) {

  const [visible, setVisible] = useState(false)
  const [value, setValue] = useState('')
  const [user, setUser] = useActiveState('user')
  const [isCheckAuth, setIsCheckAuth] = useState(false);
  const [config] = useActiveState('config');
  const [authData, setAuthData] = useState({});
  const inputRef = useRef()

  useEffect(() => {
    setVisible(props.visible)
  }, [props.visible])

  const certifiy = useLockFn(() => {
    if (!authData.real_name) {
      Dialog.info('请输入姓名');
      return;
    }
    if (!authData.identity_card) {
      Dialog.info('请输入身份证号');
      return;
    }
    Dialog.loading();
    general.axios.post('/user/user/editMemberInfo', { real_name: authData.real_name, identity_card: authData.identity_card })
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let { status, data } = res.data;

        if (!status.succeed) {
          Dialog.info(status.error_desc);
        } else {
          Dialog.info("认证成功");
          setIsCheckAuth(false);
          // setUser({...user, isRealNameAuth: true});
          setUser({ ...user, ...{ real_name: authData.real_name, identity_card: authData.identity_card, isRealNameAuth: true, isAdult: data.isAdult } });
        }
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  })

  const done = () => {

    if (user.isCheckAuth && !user.isRealNameAuth) {
      setIsCheckAuth(true)
      return
    }

    if (!user.mobile) {
      Dialog.confirm({
        title: '没有绑定手机号，现在去绑定？',
        yes: () => {
          props.handleDismiss()
          setTimeout(() => {
            general.history.push('/user/phone');
          }, 300);
        }
      });
      return
    }

    if (inputRef.current.value.length == 0) {
      return
    }
    if (inputRef.current.value.indexOf('.') != -1) {
      Dialog.error('请输入整数')
      return
    }
    if (parseFloat(inputRef.current.value) < parseFloat(props.trade.sell_price) * parseFloat(1 - props.trade.negotiated_ratio)) {
      Modal.show({
        bodyClassName: 'modify-price-alert',
        title: <div style={{ fontSize: '17px', padding: '5px', color: '#282828', textAlign: 'center', fontWeight: '500' }}>温馨提示</div>,
        content: <div style={{ fontSize: '13px', textAlign: 'center', color: '#666' }}>{'价格必须大于等于￥' + Math.ceil(parseFloat(props.trade.sell_price) * parseFloat(1 - props.trade.negotiated_ratio))}</div>,
        actions: [
          {
            key: "know",
            text: "确定",
            className: 'less-than-now',
            onClick: () => {
              Modal.clear()
            }
          },
        ]
      })
      return
    }
    if (parseFloat(inputRef.current.value) > parseFloat(props.trade.sell_price) * (1 + parseFloat(props.trade.negotiated_ratio))) {
      Modal.show({
        bodyClassName: 'modify-price-alert',
        title: <div style={{ fontSize: '17px', padding: '5px', color: '#282828', textAlign: 'center', fontWeight: '500' }}>温馨提示</div>,
        content: <div style={{ fontSize: '13px', textAlign: 'center', color: '#666' }}>{'价格必须小于￥' + Math.ceil(parseFloat(props.trade.sell_price) * (1 + parseFloat(props.trade.negotiated_ratio)))}</div>,
        actions: [
          {
            key: "know",
            text: "确定",
            className: 'less-than-now',
            onClick: () => {
              Modal.clear()
            }
          },
        ]
      })
      return
    }
    general.axios.post('/bargaining', {
      trade_id: props.trade.trade_id,
      bargain_price: inputRef.current.value
    }).then(res => {
      const { status } = res.data
      if (status.succeed) {
        Dialog.success('议价提交成功', () => props.handleDismiss())
      } else {
        Dialog.error(status.error_desc)
      }
    })
  }

  return (
    <div>
      <Popup
        visible={visible}
        bodyStyle={{
          borderTopLeftRadius: '13px',
          borderTopRightRadius: '13px',
        }}
      >
        <div className='bargain-index'>
          <div className="close" onClick={() => {
            setValue('')
            inputRef.current.value = ''
            props.handleDismiss()
          }}>
            <CloseOutlined></CloseOutlined>
          </div>
          <div className="header">
            <div className="title">议价</div>
            <div className="desc">对同一个出售的小号每天只能议价一次，议价不得低于原价的{100 - parseFloat(props.trade.negotiated_ratio) * 100}%</div>
          </div>
          <div className="container">
            <div className="item">
              <div className="title">商品原价</div>
              <div className="title">￥{props.trade.sell_price}</div>
            </div>
            <div className="item">
              <div className="title">您的出价</div>
              <input autoComplete='off' className='title input' maxLength={6} onChange={e => setValue(e.target.value)} ref={inputRef} type="text" pattern='[0-9]*' placeholder='请输入您的出价' />
            </div>
            <div className="tips">
              {parseFloat(value) < parseFloat(props.trade.sell_price) * parseFloat(1 - props.trade.negotiated_ratio) && <div>{'价格必须大于等于' + Math.ceil(parseFloat(props.trade.sell_price) * parseFloat(1 - props.trade.negotiated_ratio)) + '元'}</div>}
              {parseFloat(value) > parseFloat(props.trade.sell_price) * (1 + parseFloat(props.trade.negotiated_ratio)) && <div>{'价格必须小于' + Math.ceil(parseFloat(props.trade.sell_price) * (1 + parseFloat(props.trade.negotiated_ratio))) + '元'}</div>}
            </div>
          </div>
          <div className="done" onClick={done}>出价</div>
        </div>

      </Popup>

      {isCheckAuth ?
        <div className="pay-check-auth">
          <div className="auth-index">
            <div className="close" onClick={() => setIsCheckAuth(false)}>
              <img src="/resources/user/close.png" />
            </div>
            <div className="title">
              <div className="title-img">
                <img src="/resources/user/auth-title.png" />
              </div>
              <div>
                <h3>实名认证</h3>
                <p>
                  {config.authTopTips}
                </p>
              </div>
            </div>

            <div className="auth-user-realname">
              <div className="auth-user-input">
                <div className="name">真实姓名</div>
                <input name="nick_name" type="text" placeholder="请输入姓名" autoComplete="off" value={authData.real_name} onChange={e => setAuthData({ ...authData, real_name: e.target.value })} />
              </div>
              <div className="auth-user-input">
                <div className="name">身份证号</div>
                <input name="number" type="text" placeholder="请输入身份证号" autoComplete="off" value={authData.identity_card} onChange={e => setAuthData({ ...authData, identity_card: e.target.value })} />
              </div>
              <span>
                {config.authBottomTips}
              </span>
              <div className="auth-user-btn" onClick={certifiy}>立即认证</div>
            </div>
          </div>
        </div> : null
      }
    </div>
  )
}
